export{useDefaultLocationModal}from"../../../components/DefaultLocationModalProvider/index.web";